<template>
    <div>
        <img alt="Vue logo" src="../assets/logo.png">
        <h1>FHK Report Online Storage</h1>
        <LocalCombine/>
    </div>
</template>

<script>
    // @ is an alias to /src
    // import StorageTool from '@/components/StorageTool.vue'
    import LocalCombine from '@/components/LocalCombine'

    export default {
        name: 'Home',
        components: {
            LocalCombine
        }
    }
</script>
